import { render, staticRenderFns } from "./DownloadOrder.vue?vue&type=template&id=24fb3608&scoped=true&"
import script from "./DownloadOrder.vue?vue&type=script&lang=js&"
export * from "./DownloadOrder.vue?vue&type=script&lang=js&"
import style0 from "./DownloadOrder.vue?vue&type=style&index=0&id=24fb3608&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "24fb3608",
  null
  
)

export default component.exports